// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home-carousel-m__wrapper__aUONV"};